export enum ReportApiRoutes {
  AchRefunds = '/reports/ach-refunds',
  CancelPendings = '/reports/cancel-pendings',
  CancelRewrites = '/reports/cancel-rewrites',
  DealLog = '/reports/deal-log',
  MissingDownPayment = '/reports/missing-down-payment',
  PhysicalChecks = 'reports/physical-check-report-results',
  SearchPhysicalChecks = 'reports/search-physical-check-completion-report',
  UploadPhysicalChecks = 'reports/upload-physical-check-report',
  PostDateDeclines = '/reports/post-date-declines',
  TransferOwnershipMarkComplete = '/reports/transfer-of-ownership/:id/mark-complete',
  TransferOwnerships = '/reports/transfer-of-ownership',
  NonEDSTransferOwnershipMarkComplete = '/reports/non-eds-transfer-of-ownership/:id/mark-complete',
  NonEDSTransferOwnerships = '/reports/non-eds-transfer-of-ownership',
  ProRatedRefunds = '/reports/pro-rated-refunds',
  RetentionDiscounts = '/reports/retention-discounts',
  Assign = '/reports/assign',
  Unassign = '/reports/unassign',
  RemoveRetentionDiscountsReport = '/reports/retention-discounts/:id/complete',
  ContractTransmittalEventsErrorReport = '/reports/contract-transmittal-events-errors',
  DuplicateSaves = '/reports/retention-duplicates',
  ContractTransmittalEventErrorMarkTransmittedToAdmin = '/reports/contract-transmittal-events-errors/:id/mark-transmitted-to-admin',
  TotalLossReport = '/reports/totallossreport/:id',
  FundedFullRefunds = '/reports/funded-full-refunds',
  CarfaxReports = '/reports/carfax/:id',
  InProgressFulfillments = '/reports/in-progress-fulfillments',
  UnfulfilledContracts = '/reports/unfulfilled-contracts',
}
